<template>
  <DsPageLayout
    :theme="theme"
    prevent-loading
  >
    <!-- <template #cookie-bar>
        <PageCookieBar />
      </template> -->
    <template #header="{ headerTheme }">
      <LayoutPageHeader
        v-if="navigationData?.globalNavigationData?.main"
        :header-theme="headerTheme"
        :navigation-data="navigationData.globalNavigationData.main"
        :hide-search="false"
        hide-loading
        logo-as-nuxt-link
      />
      <div
        id="portal-header"
        ref="headerPortal"
        class="header-portal"
        @change="handleHeaderPortalUpdate($event, headerPortal)"
      />
      <DsNotificationBar
        v-if="notification"
        :close-conditions="{
          manual: true,
          auto: false,
          autoTime: 0 // ms
        }"
        :link="notification.link"
        :icon="notification.icon"
        @close="dismissNotification"
      />
    </template>
    <template #content>
      <div
        :style="{ paddingTop: `${headerPortalHeight}px` }"
        class="ds-width-full"
      >
        <slot />
      </div>
    </template>
    <template #footer>
      <LayoutPageFooter
        v-if="navigationData?.globalFooterData?.main"
        :footer-data="navigationData.globalFooterData.main"
      />
    </template>
    <template #overlay>
      <div id="portal-overlay" />
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-once
      v-html="NO_SCRIPT_HTML"
    />
    <!-- eslint-enable vue/no-v-html -->
  </DsPageLayout>
</template>

<script setup>
/**
 * Default Layout
 * will be used on pages where there is no custom layout set
 */
import { NO_SCRIPT_HTML } from '#layers/core/constants/noScriptHtml'
import { DsPageLayout, DsNotificationBar } from 'awds'

const GREY_THEME_PAGES = ['partners-network']

const headerPortal = ref()

const { handleHeaderPortalUpdate, headerPortalHeight } = useLayout()
const route = useRoute()
const { theme } = useTheme()
const { notification, dismissNotification } = useNotificationBanner()
const { fetchNavigationData } = useNavigationData()
const navigationData = await fetchNavigationData()

watchEffect(() => {
  if (GREY_THEME_PAGES.some((slug) => route.name?.includes(slug))) {
    theme.value = 'grey'
    return
  }

  theme.value = 'light'
})
</script>
